module.exports = __webpack_public_path__ + "img/tiktok-screen.c15cdb12.png";